var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[_c('b-container',{attrs:{"fluid":""}},[_c('MainMenu'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }